import { ContactStation, ScheduleTask, SelectedContact, SelectedScheduleTask, ScenarioResponseType } from "../types";
import { SCENARIO_DEPLOYMENT_TYPES } from "../../simulate/constants";

/**
 * Operate mode is active when:
 * - dashboard === 'operate' OR
 * - scenarioDeploymentType === TRUETWIN_COMMAND_CENTER OR
 * - scenarioDeploymentType === VALIDATE
 */
export const isOperateMode = (dashboard: string | undefined, scenario: ScenarioResponseType | null): boolean => {
    const deploymentType = scenario?.scenarioDeploymentType?.toUpperCase();
    return dashboard === 'operate' || deploymentType === SCENARIO_DEPLOYMENT_TYPES.TRUETWIN_COMMAND_CENTER || deploymentType === SCENARIO_DEPLOYMENT_TYPES.VALIDATE;
}

/**
 * Helper function to check if summary mode is active
 * Summary mode is active when:
 * - dashboard === 'summary' OR
 * - scenario status === 'SimulationCompleted' (for any deployment type including TRUETWIN_COMMAND_CENTER)
 */
export const isSummaryMode = (dashboard: string | undefined, scenario: ScenarioResponseType | null): boolean => {
    return dashboard === 'summary' || scenario?.status === 'SimulationCompleted';
}

// SCHEDULE CALCULATION RELATED FUNCTIONS // 

export const get_ongoing_task = (current_time: number, scheduleData: ScheduleTask[]) => {
    return scheduleData.filter((item: ScheduleTask) => item.startTime <= current_time && item.endTime >= current_time)
}


export const get_previous_task = (current_time: number, scheduleData: ScheduleTask[]) => {
    const previous_task = scheduleData.filter((item: ScheduleTask) => item.endTime < current_time)
    return previous_task.length > 0 ? [previous_task[previous_task.length - 1]] : []
}
export const get_upcoming_task = (current_time: number, scheduleData: ScheduleTask[]) => {
    const upcoming_task = scheduleData.filter((item: ScheduleTask) => item.startTime > current_time)
    return upcoming_task.length > 0 ? [upcoming_task[0]] : []
}

export const get_current_onboard_details = (current_time: number, scheduleData: ScheduleTask[], selectedScheduleTask: SelectedScheduleTask) => {
    if (!scheduleData) return
    const ongoing_task = get_ongoing_task(current_time, scheduleData)
    const prevoius_task = get_previous_task(current_time, scheduleData)
    const upcoming_task = get_upcoming_task(current_time, scheduleData)
    if (selectedScheduleTask.default_schedule) {
        return {
            ...selectedScheduleTask,
            schedule_data: ongoing_task?.length > 0 ? ongoing_task[0] : prevoius_task?.length > 0 ? prevoius_task[0] : upcoming_task[0]
        }
    }
}

// CONTACTS CALCULATION RELATED FUNCTIONS // 

export const getContactStatus = (contacts: ContactStation[], currentTime: number) => {
    let ongoingContact: ContactStation[] = [];
    let upcomingContact: ContactStation[] = [];
    let latestPreviousContact: ContactStation[] = [];

    for (const pass of contacts) {
        if (currentTime >= pass?.['startTime'] && currentTime <= pass?.['endTime']) {
            ongoingContact.push(pass)
        } else if (currentTime < pass?.['startTime']) {
            upcomingContact.push(pass);
        } else if (currentTime > pass?.['endTime']) {
            latestPreviousContact.push(pass);
        }
    }
    return {
        ongoing_contacts: ongoingContact?.length > 0 ? ongoingContact : null,
        upcoming_contacts: upcomingContact?.length > 0 ? upcomingContact : null,
        previous_contacts: latestPreviousContact?.length > 0 ? latestPreviousContact : null,
    }
}


export const get_current_contact_details = (current_time: number, timelineContactData: ContactStation[], selectedContact: SelectedContact) => {
    const { ongoing_contacts, upcoming_contacts, previous_contacts } = getContactStatus(timelineContactData, current_time);
    ongoing_contacts?.sort((a, b) => a.startTime - b.startTime);
    upcoming_contacts?.sort((a, b) => a.startTime - b.startTime);
    previous_contacts?.sort((a, b) => b.startTime - a.startTime);

    const selected_contact: SelectedContact = ongoing_contacts
        ? { selection_type: 'auto', contact_type: 'Ongoing', contact_data: ongoing_contacts[0] }
        : upcoming_contacts
            ? { selection_type: 'auto', contact_type: 'Upcoming', contact_data: upcoming_contacts[0] }
            : previous_contacts
                ? { selection_type: 'auto', contact_type: 'Previous', contact_data: previous_contacts[0] }
                : null;


    if (selected_contact && (!selectedContact || selectedContact.selection_type === 'auto' || (selectedContact.selection_type === 'manual' && selectedContact?.contact_data?.uniqueId === selected_contact?.contact_data?.uniqueId))) {
        return {
            contacts: {
                previous_contacts,
                ongoing_contacts,
                upcoming_contacts,
                current_time: current_time,
            },
            selected_contact
        }
    } else {
        return {
            contacts: {
                previous_contacts,
                ongoing_contacts,
                upcoming_contacts,
                current_time: current_time,
            }
        }
    }
}